import React from "react";
import Select, { createFilter } from "react-select";
import { InputLabel } from "@mui/material";

// react-select's default filter stringifies `${label} ${value}`, so queries like "10"
// match options whose *value* contains "10" (e.g. id 1012) even when the label does not.
const filterByVisibleLabel = createFilter({
  stringify: (option) => {
    const { label, value } = option;
    if (label !== undefined && label !== null && label !== "") return String(label);
    return value !== undefined && value !== null ? String(value) : "";
  },
});

const renderError = (formik, keyField) => {
  if (!formik || !keyField) return null;
  const keyFieldParts = keyField?.split(".");

  if (keyFieldParts?.length === 3 && formik?.errors[keyFieldParts[0]]) {
    const errorString = formik?.errors[keyFieldParts[0]]?.[keyFieldParts[1]]?.[keyFieldParts[2]];
    return errorString ? <div className="error-text">{errorString}</div> : null;
  }
  return formik?.errors[keyField] ? <div className="error-text" style={{paddingTop: "20px"}}>{formik?.errors[keyField]}</div> : null;
};

const SearchSelect = ({
  label,
  options = [],
  value,
  onChange,
  placeholder = "Select",
  required = false,
  hideRequired = false,
  isLoading = false,
  isDisabled = false,
  isClearable = true,
  isMulti = false,
  className = "search-select",
  classNamePrefix = "select",
  name,
  formik,
  keyField,
  labelStyle,
  ...props
}) => {
  return (
    <div className="field-wrap">
      {label && (
        <InputLabel style={{ fontWeight: 400, fontSize: "18px", color: "black", marginBottom: "10px", ...labelStyle }}>
          {label}
          {hideRequired ? null : required ? <span style={{ color: "red" }}> *</span> : null}
        </InputLabel>
      )}
      <Select
        name={name || keyField}
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        classNamePrefix={classNamePrefix}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable={true}
        isMulti={isMulti}
        isLoading={isLoading}
        filterOption={filterByVisibleLabel}
        {...props}
      />
      {renderError(formik, keyField)}
    </div>
  );
};

export default SearchSelect;
